import BaseCustomizeInput from "components/GhiPlanSetup";
import DiseaseWiseLimit from "components/GhiPlanSetup/DiseaseWiseLimit";
import MaternityCoverge from "components/GhiPlanSetup/MaternityCoverage";
import CoPay from "components/PlanSetup/CoPay";
import CorporateBuffer from "components/PlanSetup/CorporateBuffer";
import OpdLimit from "components/PlanSetup/OpdLimit";
import WellnessBenefits from "components/PlanSetup/WellnessBenefits";
import {
  BaseDropdown,
  BaseInput,
  LargeButton,
  OverlayLoader,
} from "components/core";
import { Formik, Form } from "formik";
import { values } from "lodash";
import {
  flexGhiSchema,
  attributeInitialValues,
  flexGhiPlanSetup,
} from "pages/FlexSetup/AttributeSetup/attributesPros";
import React, { useEffect, useState } from "react";
import useFlex from "hooks/useFlex";

const AttributesForm = ({ details, besicDetails }) => {
  const { next, getProductDetails } = useFlex();
  const [isLoading, setLoading] = useState(false);
  const [selectedAttributes, setAttributes] = useState();
  const getOptions = (details) => {
    if (!details) return [];
    return details.map(({ display_name, value }) => ({
      label: display_name,
      value,
    }));
  };
  const handleSubmit = async (values, { setTouched }) => {
    setTouched(
      Object.keys(values).reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {})
    );
    try {
      const response = flexGhiPlanSetup(values, setLoading, details);
      next();
    } catch (error) {
      // Handle the error here
      console.error('An error occurred:', error);
    }
    
  };
  return (
    <>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <Formik
          validationSchema={flexGhiSchema(details)}
          initialValues={attributeInitialValues}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (
            <div style={{ marginBottom: "2.8rem" }}>
              <Form>
                {details && details["sum_insured"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="Sum Insured"
                      options={getOptions(details["sum_insured"])}
                      formikProps={{ ...formikProps, name: "sum_insured" }}
                    />
                  </div>
                )}
                {details && details["room_limit"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="Room Limit"
                      options={getOptions(details["room_limit"])}
                      formikProps={{ ...formikProps, name: "room_limit" }}
                    />
                  </div>
                )}
                {formikProps.values.room_limit ==
                  "Customise Limit (by metro & Non metro)" && (
                  <BaseCustomizeInput
                    label={"Room Limit"}
                    formikProps={formikProps}
                  />
                )}
                {details && details["maternity_coverage"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="Maternity"
                      options={getOptions(details["maternity_coverage"])}
                      formikProps={{
                        ...formikProps,
                        name: "maternity_coverage",
                      }}
                    />
                  </div>
                )}
                {formikProps.values.maternity_coverage == true && (
                  <MaternityCoverge
                    label={"Room Limit"}
                    formikProps={formikProps}
                  />
                )}
                {details && details["utilization_limit_for_parents"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="Utilization Limit for Parents"
                      options={getOptions(
                        details["utilization_limit_for_parents"]
                      )}
                      formikProps={{
                        ...formikProps,
                        name: "utilization_limit_for_parents",
                      }}
                    />
                  </div>
                )}
                {details && details["disease_wise_limit"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="Disease-wise Limit"
                      options={getOptions(details["disease_wise_limit"])}
                      formikProps={{
                        ...formikProps,
                        name: "disease_wise_limit",
                      }}
                    />
                  </div>
                )}
                {formikProps.values.disease_wise_limit == "Yes" && (
                  <DiseaseWiseLimit
                    formikProps={formikProps}
                    dropDownValues={getOptions(details["disease_names"])}
                  />
                )}
                {details && details["co_pay"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="Co-pay"
                      options={getOptions(details["co_pay"])}
                      formikProps={{ ...formikProps, name: "co_pay" }}
                    />
                  </div>
                )}
                {formikProps.values.co_pay &&
                  formikProps.values.co_pay !== "No" && (
                    <CoPay formikProps={formikProps} />
                  )}
                {details && details["waiting_period"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="Waiting Period"
                      options={getOptions(details["waiting_period"])}
                      formikProps={{ ...formikProps, name: "waiting_period" }}
                    />
                  </div>
                )}
                {details && details["opd_included"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="OPD"
                      options={getOptions(details["opd_included"])}
                      formikProps={{ ...formikProps, name: "opd_included" }}
                    />
                  </div>
                )}
                {formikProps.values.opd_included == true && (
                  <OpdLimit formikProps={formikProps} />
                )}
                {details && details["wellness_benefits_options"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="Wellness Benefit Options"
                      options={getOptions(details["wellness_benefits_options"])}
                      formikProps={{
                        ...formikProps,
                        name: "wellness_benefits_options",
                      }}
                    />
                  </div>
                )}
                {formikProps.values.wellness_benefits_options == "Yes" && (
                  <WellnessBenefits
                    displayVlaues={details["wellness_benefits"]}
                    onChange={setAttributes}
                    formikProps={{
                      ...formikProps,
                      name: "wellness_benefits",
                    }}
                  />
                )}
                {details && details["corporate_buffer"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="Corporate Buffer"
                      options={getOptions(details["corporate_buffer"])}
                      formikProps={{ ...formikProps, name: "corporate_buffer" }}
                    />
                  </div>
                )}
                {formikProps.values.corporate_buffer == true && (
                  <CorporateBuffer formikProps={formikProps} />
                )}
                {details && details["premium_contribution"] && (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseDropdown
                      fontSize="14"
                      label="Premium Contribution"
                      options={getOptions(details["premium_contribution"])}
                      formikProps={{
                        ...formikProps,
                        name: "premium_contribution",
                      }}
                    />
                  </div>
                )}
                {
                // details && details["ambulance_limit"] && it's a mandatory frield
                (
                  <div style={{ marginBottom: "2.8rem" }}>
                    <BaseInput
                      label="Enter Ambulance Limit"
                      type="text"
                      formikProps={{ ...formikProps, name: "ambulance_limit" }}
                    />
                  </div>
                )}
                <div style={{ marginTop: "4rem" }}>
                  <LargeButton
                    type="submit"
                    label="Save & Next"
                    marginTop="2rem"
                  />
                </div>
              </Form>
            </div>
          )}
        </Formik>
      )}
    </>
  );
};
export default AttributesForm;
